import { render, staticRenderFns } from "./xuekezhixuan.vue?vue&type=template&id=fcc206ba&scoped=true"
import script from "./xuekezhixuan.vue?vue&type=script&lang=js"
export * from "./xuekezhixuan.vue?vue&type=script&lang=js"
import style0 from "./xuekezhixuan.vue?vue&type=style&index=0&id=fcc206ba&prod&lang=less&scoped=true"
import style1 from "./xuekezhixuan.vue?vue&type=style&index=1&id=fcc206ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc206ba",
  null
  
)

export default component.exports